/**
 * Timpii din bara de căutare.
 *
 * Sugestiile apar după o pauză foarte scurtă, iar căutarea live (care înlocuiește
 * lista de sugestii cu produse) așteaptă mai mult: altfel rezultatele ajungeau
 * înaintea sugestiilor și vizitatorul nu apuca să le vadă.
 */
export const SUGGEST_DEBOUNCE_MS = 120;
export const LIVE_SEARCH_DELAY_MS = 450;
